/**
 * PornographyLikelihood
 *
 * Mirrors Flutter's `PornographyLikelihood` enum
 * (lib/domain/enums/pornography_likelihood.dart). Numeric values are the
 * underlying Firestore `explicit` field on a media document.
 */
export enum PornographyLikelihood {
  unknown = 0,
  veryUnlikely = 1,
  unlikely = 2,
  possible = 3,
  likely = 4,
  veryLikely = 5,
}

/**
 * Threshold used for NSFW gating across the app. Matches Flutter's
 * `PornographyLikelihood.allowedPornographyLikelihood` getter — content is
 * considered NSFW when its `explicit` value is **strictly greater** than this.
 */
export const ALLOWED_PORNOGRAPHY_LIKELIHOOD = PornographyLikelihood.possible;
